export const msToMinutes = (ms: number) => {
  return Math.round(ms / (1000 * 60))
}
